// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GlaromatUserModel from '../../model/glaromat-user-model';
import GlaromatUserDTO from '../dto/glaromat-user-dto';
import dtoSchema from '../schemas/glaromat-user-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class GlaromatUserModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GlaromatUserDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.siHaAgbAccepted = data.siHaAgbAccepted;
      this.companyLogoDocumentExternalId = data.companyLogoDocumentExternalId ?? undefined;
      this.companyName = data.companyName ?? undefined;
      this.companyAddress = data.companyAddress ?? undefined;
      this.firstName = data.firstName ?? undefined;
      this.lastName = data.lastName ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  */
  siHaAgbAccepted?: boolean;
  /**
  */
  companyLogoDocumentExternalId?: string;
  /**
  * @maximum 255
  */
  companyName?: string;
  /**
  * @maximum 255
  */
  companyAddress?: string;
  /**
  * @maximum 255
  */
  firstName?: string;
  /**
  * @maximum 255
  */
  lastName?: string;

  static toModel(dto: DeepPartial<GlaromatUserDTO>): GlaromatUserModel;
  static toModel(dto: DeepPartial<GlaromatUserDTO> | undefined | null): GlaromatUserModel | undefined;
  static toModel(dto: DeepPartial<GlaromatUserDTO> | undefined | null): GlaromatUserModel | undefined {
    return dto ? new GlaromatUserModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GlaromatUserModel> | GlaromatUserModel): GlaromatUserDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      siHaAgbAccepted: unwrapped.siHaAgbAccepted,
      companyLogoDocumentExternalId: unwrapped.companyLogoDocumentExternalId,
      companyName: unwrapped.companyName,
      companyAddress: unwrapped.companyAddress,
      firstName: unwrapped.firstName,
      lastName: unwrapped.lastName,
    } as GlaromatUserDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GlaromatUserModel, can not map to GlaromatUserDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
